import { Component, Inject, OnInit } from '@angular/core';
import { CustomIconService } from 'src/app/core/services/custom-icon.service';
import { UserService } from '../../../../../../../core/services/user.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-flow-publish-modal',
  templateUrl: './flow-publish-modal.component.html',
  styleUrls: ['./flow-publish-modal.component.scss'],
})
export class FlowPublishModal implements OnInit {
  model: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private customIconService: CustomIconService,

    private userService: UserService
  ) { }

  ngOnInit() {
    this.model.partner = this.data.partner;
    this.model.account = this.data.account;
    this.model.user = this.userService.user;
    this.customIconService.init();
  }

}
